export const defaultImageLink= "https://chestermania.com/shop/wp-content/uploads/2013/03/featured-blog-post-image-1024x574.jpg"
export const shareLink = "https://blooggerr.netlify.app/blogs/"
